import React, { useEffect, useState } from 'react';
import { useEmailValue, useLoginIdValue, usePhoneNumberValue } from '@/hooks/tab';
import { useCurrentEmailItem, useCurrentLoginIdItem, useCurrentPhoneNumberItem } from '@/hooks/reference';
import { useClientEmail, useClientId, useClientPhoneNumber } from '@/hooks/client';
import { Heading } from '@/components/atoms/Section';
import { ClientEmailView, ClientIdView, ClientPhoneNumberView } from '@/components/organisms/client/Client';
import { ItemStandalone } from '@/components/organisms/section/Item';
import styles from './Common.module.scss';
import { formatPhoneNumber } from '@/utilities/client';

export const EmailView: React.FC = () => {
  const [inputValue] = useEmailValue();
  const [currentItem] = useCurrentEmailItem();
  const [item, setItem] = useState(currentItem);
  const data = useClientEmail(inputValue);
  const id = Number(item);

  useEffect(() => {
    if (currentItem !== '' && currentItem !== item) {
      setItem(currentItem);
    }
  }, [currentItem]);

  const client = data.kind === 'Loaded' ? (data.data[0] ?? null) : null;
  const name = client?.name ?? '';
  const personaKycStatus = client?.personaKycStatus ?? null;
  if (currentItem) {
    return (
      <div className={styles.wrapperItem}>
        <ItemStandalone id={id} />
      </div>
    );
  }

  return (
    <>
      <div
        className={styles.container}
        data-cy={`PageContent-client__${id}`}
      >
        {name !== '' && (
          <div className={styles.headingContainer}>
            <div className={styles.headingOrder}>
              <Heading
                label={name}
                personaKycStatus={personaKycStatus}
              />
            </div>
          </div>
        )}
        <div
          className={styles.sectionWrapper}
          data-cy={`PageContent-client__${id}_content`}
        >
          <div className={styles.wrapper}>
            <ClientEmailView
              email={inputValue}
              isBuyer={false}
              showKycBadge={false}
            />
          </div>
        </div>
      </div>
    </>
  );
};

export const IdView: React.FC = () => {
  const [inputValue] = useLoginIdValue();
  const [currentItem] = useCurrentLoginIdItem();
  const [item, setItem] = useState(currentItem);
  const data = useClientId(Number(inputValue));
  const id = Number(item);

  useEffect(() => {
    if (currentItem !== '' && currentItem !== item) {
      setItem(currentItem);
    }
  }, [currentItem]);

  const client = data.kind === 'Loaded' ? (data.data[0] ?? null) : null;
  const name = client?.name ?? '';
  const personaKycStatus = client?.personaKycStatus ?? null;

  if (currentItem) {
    return (
      <div className={styles.wrapperItem}>
        <ItemStandalone id={id} />
      </div>
    );
  }

  return (
    <>
      <div
        className={styles.container}
        data-cy={`PageContent-loginId__${id}`}
      >
        {name !== '' && (
          <div className={styles.headingContainer}>
            <div className={styles.headingOrder}>
              <Heading
                label={name}
                personaKycStatus={personaKycStatus}
              />
            </div>
          </div>
        )}
        <div
          className={styles.sectionWrapper}
          data-cy={`PageContent-loginId__${id}_content`}
        >
          <div className={styles.wrapper}>
            <ClientIdView
              id={Number(inputValue)}
              isBuyer={false}
              showKycBadge={false}
            />
          </div>
        </div>
      </div>
    </>
  );
};

export const PhoneNumberView: React.FC = () => {
  const [inputValue] = usePhoneNumberValue();
  const [currentItem] = useCurrentPhoneNumberItem();
  const [item, setItem] = useState(currentItem);
  const data = useClientPhoneNumber(formatPhoneNumber(inputValue));
  const id = Number(item);

  useEffect(() => {
    if (currentItem !== '' && currentItem !== item) {
      setItem(currentItem);
    }
  }, [currentItem]);

  const client = data.kind === 'Loaded' ? (data.data[0] ?? null) : null;
  const name = client?.name ?? '';
  const personaKycStatus = client?.personaKycStatus ?? null;
  if (currentItem) {
    return (
      <div className={styles.wrapperItem}>
        <ItemStandalone id={id} />
      </div>
    );
  }

  return (
    <>
      <div
        className={styles.container}
        data-cy={`PageContent-phoneNumber__${formatPhoneNumber(inputValue)}`}
      >
        {name !== '' && (
          <div className={styles.headingContainer}>
            <div className={styles.headingOrder}>
              <Heading
                label={name}
                personaKycStatus={personaKycStatus}
              />
            </div>
          </div>
        )}
        <div
          className={styles.sectionWrapper}
          data-cy={`PageContent-phoneNumber__${formatPhoneNumber(inputValue)}_content`}
        >
          <div className={styles.wrapper}>
            <ClientPhoneNumberView
              phoneNumber={formatPhoneNumber(inputValue)}
              isBuyer={false}
              showKycBadge={false}
            />
          </div>
        </div>
      </div>
    </>
  );
};
